import { useCallback, useState } from "react"

export const useBoolean = (
  initial: boolean,
): [boolean, () => void, () => void] => {
  const [bool, setBool] = useState(initial)
  const setTrue = useCallback(() => setBool(true), [])
  const setFalse = useCallback(() => setBool(false), [])
  return [bool, setTrue, setFalse]
}
